import * as React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import AchFilesJob from '../components/Admin/Jobs/AchFilesJob';
function AchFilesJobPage() {
    return (
        <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true} />
                </div>
            <div className="content-class">
                <AchFilesJob />
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
      </div>
            </>
        );
}

export default AchFilesJobPage;